import React, { Component } from 'react';
import { connect } from 'react-redux';
import { installmentsList, printInstallment } from 'src/actions/installmentAction';
import {
  Card,
  Stack,
  IconButton,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Grid
} from '@mui/material';
import Page from '../../components/Page';
import { ListHead } from '../../components/_dashboard/car';
import Scrollbar from '../../components/Scrollbar';
import Edit from '@material-ui/icons/Edit';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import ModalCompoennt from '../Portal/ModalCompoennt';
import DeleteInstallment from './DeleteInstallment';
import CloudDownload from "@material-ui/icons/CloudDownload";
import ReceiveInstallment from './ReceiveInstallments';
import Pagination from '@mui/material/Pagination';

const TABLE_HEAD = [
  { id: 'client', label: 'Client', alignRight: false },
  { id: 'provider', label: 'Provider', alignRight: false },
  { id: 'loan_amount', label: 'Loan Amount', alignRight: false },
  { id: 'frequency', label: 'Frequency', alignRight: false },
  { id: 'number_of_payments', label: 'No of Payments', alignRight: false },
  { id: 'payment_amount', label: 'Payment Amount', alignRight: false },
  { id: 'interest_rate', label: 'Interest Rate', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false }
];

class InstallmentList extends Component {

  state = {
    openDelete:false,
    installmentObj:{},
    openReceiveInstallmet:false,
    page:1,
  };
  
  componentDidMount() {
    this.props.installmentsList();
  }

  handleUpdateClick = (a) => {
    this.setState({openReceiveInstallmet:true, installmentObj:a});
  }

  hanldeDeleteClick = (a) => {
    this.setState({openDelete:true, installmentObj:a});
  }

  closeButton = () => {
    this.setState({openDelete:false, installmentObj:{}, openReceiveInstallmet:false});
  }

  handleDownloadClick = (a) => {
    const values = {};
    values.installment_id = a.id;
    values.agreement_id = a.agreement_id;
    return this.props.printInstallment(values);
  }

  renderInstallmentList = () => {
    if (!_.isEmpty(this.props.installments.data)) {
      var installments = this.props.installments.data;
      var f_installments = _.orderBy(installments, ['id'], ['desc']);
      return f_installments.map((a) => {
        return (
          <TableRow hover tabIndex={-1} key={a.id}>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.client}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.provider}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.loan_amount}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.frequency}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.number_of_payments}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.payment_amount}
            </TableCell>
            <TableCell align="left" style={{ padding: '10px' }}>
              {a.interest_rate}
            </TableCell>
            <TableCell colSpan={3}>
              <IconButton
                onClick={() => this.handleUpdateClick(a)}
                sx={{ float: 'left', padding: '0px', color: '#c29136' }}
              >
                <Edit />
              </IconButton>
              <IconButton sx={{float:"left",padding:"0px", color:"#c29136"}} onClick={() => this.handleDownloadClick(a)}>
                <CloudDownload />
              </IconButton>
              <IconButton sx={{float:"left",padding:"0px", color:"red"}} onClick={() => this.hanldeDeleteClick(a)}>
                <DeleteOutlined />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    } else {
      return (
        <TableRow>
          <TableCell colSpan={8}>No Installment Exist</TableCell>
        </TableRow>
      );
    }
  };

  handlePageChange = (event, newPage) => {
    this.setState({page:newPage});
    props.installmentsList(newPage)
  }

  render() {
    return (
      <Page title="Installment List">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Grid>
            <Typography variant="h4" gutterBottom>
              Installments List
            </Typography>
          </Grid>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} rowCount={2} />
                <TableBody>{this.renderInstallmentList()}</TableBody>
              </Table>
              <Pagination sx={{float:"right",marginTop:"10px",marginBottom:"10px"}} page={this.state.page} count={this.props.installments.paginate.last_page} variant="outlined" color="primary" onChange={this.handlePageChange} />
            </TableContainer>
          </Scrollbar>
        </Card>
        {
          this.state.openDelete &&
          <ModalCompoennt open={this.state.openDelete} onClose={this.closeButton} title="Delete" width="xs" color="red">
            <DeleteInstallment installment={this.state.installmentObj} onDismis={this.closeButton} />
          </ModalCompoennt>
        }
        {
          this.state.openReceiveInstallmet &&
          <ModalCompoennt open={this.state.openReceiveInstallmet} onClose={this.closeButton} title="Receive Installment" width="lg">
            <ReceiveInstallment installment={this.state.installmentObj} onDismis={this.closeButton} />
          </ModalCompoennt>
        }
      </Page>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    installments: state.installments
  };
};

export default connect(mapStateToProps, { installmentsList, printInstallment })(InstallmentList);